import { useEffect, useState } from "react";

const Address = lawFirm =>  {
    const [address, setAddress] = useState("");
    useEffect(() => { 
        let value = "";
        if (lawFirm.lawFirm) {
            if (lawFirm.lawFirm.streetName) { 
                value += lawFirm.lawFirm.streetName.trim();
                value += ", "
            }

            if (lawFirm.lawFirm.town) { 
                value += lawFirm.lawFirm.town.trim();
                value += ", "
            }

            if (lawFirm.lawFirm.postcode) { 
                value += lawFirm.lawFirm.postcode.trim();
            }


            //remove the trailing ', '
            value = value.replace(/,\s*$/, "");

            setAddress(value);
        }
    }, [lawFirm]);

    return <span data-testid="law-firm-address">{address}</span>
}

export default Address;
